// extracted by mini-css-extract-plugin
module.exports = {"controls":"Search_controls__3DBC0","filterIcon":"Search_filter-icon__sKDlE"};